import Swiper from 'swiper/bundle';

export default function swipers() {

    const stadiumPageSwiper = new Swiper('.js-stadium-page-swiper', {
        slidesPerView: 'auto',
        loop: true,
        navigation: {
            prevEl: ".stadium-page__swiper-prev",
            nextEl: ".stadium-page__swiper-next",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    

    setTimeout(() => {

        const textPageTeamsSwiper1 = new Swiper('.js-text-page-teams-swiper-1', {
            slidesPerView: 'auto',
            //loop: true,
            navigation: {
                prevEl: ".text-page-teams__swiper-prev-1",
                nextEl: ".text-page-teams__swiper-next-1",
            },
    
        });

        //textPageTeamsSwiper1.slideTo( 7 );
        if ( textPageTeamsSwiper1 ) {
        
            let slides = document.querySelectorAll('.js-text-page-teams-swiper-1 .swiper-slide');
            slides.forEach(slide => {
                slide.addEventListener('click', () => {
                    //alert(slide.dataset.index);
                    //console.log(slide.dataset.index);
                    document.querySelector('.js-text-page-teams-swiper-1 .swiper-slide.active').classList.remove('active');
                    slide.classList.add('active');
                    setTimeout(() => {
                        textPageTeamsSwiper1.slideTo(+slide.dataset.index - 1);
                    }, 10);

                    document.querySelector('.js-text-page-teams-box-1.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-box-1[data-box="${slide.dataset.index}"]`).classList.add('active');
                });
            });

            let prev = document.querySelector('.text-page-teams__swiper-prev-1');
            let next = document.querySelector('.text-page-teams__swiper-next-1');

            if ( prev ) {
                prev.addEventListener('click', () => {
                    document.querySelector('.js-text-page-teams-swiper-1 .swiper-slide.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-swiper-1 .swiper-slide[data-index="${textPageTeamsSwiper1.realIndex + 1}"]`).classList.add('active');
                    document.querySelector('.js-text-page-teams-box-1.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-box-1[data-box="${textPageTeamsSwiper1.realIndex + 1}"]`).classList.add('active');
                });
            }
            if ( next ) {
                next.addEventListener('click', () => {
                    document.querySelector('.js-text-page-teams-swiper-1 .swiper-slide.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-swiper-1 .swiper-slide[data-index="${textPageTeamsSwiper1.realIndex + 1}"]`).classList.add('active');
                    document.querySelector('.js-text-page-teams-box-1.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-box-1[data-box="${textPageTeamsSwiper1.realIndex + 1}"]`).classList.add('active');
                });
            }

        }



        const textPageTeamsSwiper2 = new Swiper('.js-text-page-teams-swiper-2', {
            slidesPerView: 'auto',
            //loop: true,
            navigation: {
                prevEl: ".text-page-teams__swiper-prev-2",
                nextEl: ".text-page-teams__swiper-next-2",
            },
    
        });

        //textPageTeamsSwiper2.slideTo( 7 );
        if ( textPageTeamsSwiper2 ) {
        
            let slides = document.querySelectorAll('.js-text-page-teams-swiper-2 .swiper-slide');
            slides.forEach(slide => {
                slide.addEventListener('click', () => {
                    //alert(slide.dataset.index);
                    //console.log(slide.dataset.index);
                    document.querySelector('.js-text-page-teams-swiper-2 .swiper-slide.active').classList.remove('active');
                    slide.classList.add('active');
                    setTimeout(() => {
                        textPageTeamsSwiper2.slideTo(+slide.dataset.index - 1);
                    }, 10);

                    document.querySelector('.js-text-page-teams-box-2.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-box-2[data-box="${slide.dataset.index}"]`).classList.add('active');
                });
            });

            let prev = document.querySelector('.text-page-teams__swiper-prev-2');
            let next = document.querySelector('.text-page-teams__swiper-next-2');

            if ( prev ) {
                prev.addEventListener('click', () => {
                    document.querySelector('.js-text-page-teams-swiper-2 .swiper-slide.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-swiper-2 .swiper-slide[data-index="${textPageTeamsSwiper2.realIndex + 1}"]`).classList.add('active');
                    document.querySelector('.js-text-page-teams-box-2.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-box-2[data-box="${textPageTeamsSwiper2.realIndex + 1}"]`).classList.add('active');
                });
            }
            if ( next ) {
                next.addEventListener('click', () => {
                    document.querySelector('.js-text-page-teams-swiper-2 .swiper-slide.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-swiper-2 .swiper-slide[data-index="${textPageTeamsSwiper2.realIndex + 1}"]`).classList.add('active');
                    document.querySelector('.js-text-page-teams-box-2.active').classList.remove('active');
                    document.querySelector(`.js-text-page-teams-box-2[data-box="${textPageTeamsSwiper2.realIndex + 1}"]`).classList.add('active');
                });
            }

        }



    }, 500);








    const partnersSwiper = new Swiper('.js-partners-swiper', {
        slidesPerView: 'auto',
        //loop: true,
        enabled: true,

        breakpoints: {
            768: {
                enabled: false,
            }
        }

    });

    const partnersLegueSwiper = new Swiper('.js-partners-legue-swiper', {
        slidesPerView: 'auto',
        loop: true,
        enabled: true,

        autoplay: {
            delay: 0, // Нет задержки между переходами
            disableOnInteraction: false, // Продолжать после взаимодействия пользователя
        },
        speed: 5000, // Скорость прокрутки (меньше = быстрее)
        freeMode: true, // Свободный режим для плавности

        
        // Дополнительные настройки для лучшего эффекта
        resistance: false, // Отключить сопротивление при перетаскивании
        watchSlidesProgress: true,
        centeredSlides: false,
        initialSlide: 0,

        breakpoints: {
            768: {
                enabled: false,
            },
            loop: false,

        }

    });

    const mediaSwiper = new Swiper('.js-media-swiper', {
        slidesPerView: 'auto',
        //loop: true,
        enabled: true,

        breakpoints: {
            768: {
                enabled: false,
            }
        }

    });

    /* const videoSwiper = new Swiper('.js-video-swiper', {
        slidesPerView: 'auto',
        enabled: false
    }); */

    const personOtherSwiper = new Swiper('.js-person-other-swiper', {
        slidesPerView: 'auto',
        navigation: {
            prevEl: ".person-other__swiper-prev",
            nextEl: ".person-other__swiper-next",
        },
    });

    const mainMatchesSwiper = new Swiper('.js-main-mathces-swiper', {
        slidesPerView: 'auto',
        //loop: true,
        navigation: {
            prevEl: ".main-matches__swiper-prev",
            nextEl: ".main-matches__swiper-next",
        },
    });

    // Функция для поиска и скролла к ближайшему слайду
    function scrollToNearestMatch() {
        const slides = document.querySelectorAll('.main-matches__slide');
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Обнуляем время для точного сравнения дат
        
        let closestFutureSlideIndex = -1;
        let closestFutureDiff = Infinity;
        let closestPastSlideIndex = -1;
        let closestPastDiff = -Infinity;

        slides.forEach((slide, index) => {
            const dateElement = slide.querySelector('.js-match-date');
            if (!dateElement) return;

            const dateText = dateElement.textContent.trim();
            const [day, month] = dateText.split('.');
            
            // Создаем объект Date для даты матча (текущий год)
            const matchDate = new Date(today.getFullYear(), parseInt(month) - 1, parseInt(day));
            
            // Разница в миллисекундах
            const diff = matchDate - today;
            if (diff >= 0) {
                // Будущая дата
                if (diff < closestFutureDiff) {
                    closestFutureDiff = diff;
                    closestFutureSlideIndex = index - 2;
                    if (window.innerWidth < 769) {
                        closestFutureSlideIndex = index;
                    }
                }
            } else {
                // Прошедшая дата
                if (diff > closestPastDiff) {
                    closestPastDiff = diff;
                    closestPastSlideIndex = index - 2;
                    if (window.innerWidth < 769) {
                        closestPastSlideIndex = index;
                    }
                }
            }
        });

        // Приоритет будущим датам, если есть хотя бы одна будущая
        if (closestFutureSlideIndex !== -1) {
            mainMatchesSwiper.slideTo(closestFutureSlideIndex);
        } else if (closestPastSlideIndex !== -1) {
            // Если будущих нет, показываем ближайший прошедший
            mainMatchesSwiper.slideTo(closestPastSlideIndex);
        }
    }

    // Вызываем функцию после инициализации свайпера
    setTimeout(scrollToNearestMatch, 100);

    const administrationSwiper = new Swiper('.js-swiper-administration', {
        slidesPerView: 'auto',
    });
    
    /* const mainGallerySwiper = new Swiper('.js-gallery-swiper', {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        navigation: {
            prevEl: ".modal__gallery-prev",
            nextEl: ".modal__gallery-next",
        },
    }); */










    
    const mainFirstSwiper = new Swiper('.js-main-first-swiper', {
        slidesPerView: 'auto',
        effect: "fade",
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        navigation: {
            prevEl: ".main-first__swiper-prev",
            nextEl: ".main-first__swiper-next",
        },
    });

    const mainFirstThumbs = new Swiper('.js-main-first-thumbs', {
        slidesPerView: 'auto',
        allowTouchMove: true, // Отключаем свайп для миниатюр
        autoplay: false, // Управляем вручную

        breakpoints: {
            768: {
                allowTouchMove: false,
            }
        }
    });

    const progressBars = document.querySelectorAll('.main-first__thumbs-progress span');
    let isManualChange = false;
    let progressTimeout;
    let currentThumbIndex = 0;

    // Функция для запуска прогресса миниатюры
    function startThumbProgress(index) {
        clearTimeout(progressTimeout);
        
        // Сброс всех прогресс-баров
        progressBars.forEach(bar => {
            bar.style.transition = 'none';
            bar.style.width = '0%';
        });

        // Заполнение пройденных
        for (let i = 0; i < index; i++) {
            progressBars[i].style.width = '100%';
        }

        // Анимация текущего
        const currentBar = progressBars[index];
        if (currentBar) {
            setTimeout(() => {
                currentBar.style.transition = `width 5000ms linear`;
                currentBar.style.width = '100%';
            }, 10);

            // Переключение после завершения
            progressTimeout = setTimeout(() => {
                if (index === progressBars.length - 1) {
                    // Loop: последний → первый
                    currentThumbIndex = 0;
                    mainFirstThumbs.slideTo(0);
                    mainFirstSwiper.slideToLoop(0);
                } else {
                    currentThumbIndex = index + 1;
                    mainFirstThumbs.slideTo(currentThumbIndex);
                }
                startThumbProgress(currentThumbIndex);
            }, 5000);
        }
    }

    // Клик по миниатюре
    document.querySelectorAll('.main-first__thumbs-slide').forEach((slide, index) => {
        slide.addEventListener('click', () => {
            isManualChange = true;
            clearTimeout(progressTimeout);
            
            currentThumbIndex = index;
            mainFirstThumbs.slideTo(index);
            mainFirstSwiper.slideToLoop(index);
            startThumbProgress(index);
            
            // Перезапуск автопрокрутки основного слайдера
            setTimeout(() => {
                isManualChange = false;
                mainFirstSwiper.autoplay.start();
            }, 5000 + 100);
        });
    });

    // Связь основного слайдера с миниатюрами
    mainFirstSwiper.on('slideChangeTransitionStart', () => {
        if (!isManualChange) {
            currentThumbIndex = mainFirstSwiper.realIndex;
            mainFirstThumbs.slideTo(currentThumbIndex);
            startThumbProgress(currentThumbIndex);
        }
    });

    // Старт
    startThumbProgress(0);
}